import { UnitBase } from './base/unit-base';

export class Unit extends UnitBase { }